export default __webpack_public_path__ + "static/media/createChild.b87ae78f.png";